var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0z",
    transform: "translate(-45 -458) translate(0 48) translate(0 407) translate(45 3)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98 0L0 1.502l3.98 1.501-.356-1.074h8.754l.733.948h4.349L16.393 1.5l.61-.79.455-.588h-4.348l-.733.949H3.625L3.98 0zm9.352.811h.445l-.532.689.532.689h-.445l-.533-.69.533-.688zm1.198 0h.446l-.533.689.533.689h-.446l-.532-.69.532-.688zm1.198 0h.446l-.532.689.532.689h-.446l-.532-.69.532-.688z",
    transform: "translate(-45 -458) translate(0 48) translate(0 407) translate(45 3) translate(0 6.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.14 0.48H9.14V5.295999999999999H8.14z",
    transform: "translate(-45 -458) translate(0 48) translate(0 407) translate(45 3) translate(0 6.6)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDirection);
export default __webpack_public_path__ + "static/media/wind-direction.bd7ef6d7.svg";
export { ForwardRef as ReactComponent };